import React, { Fragment } from 'react';
import { FadeIn } from './FadeIn';
import { XIcon, CheckIcon } from 'lucide-react';
export function BeforeAfter() {
  const pairs = [{
    before: 'Improvisás cada plan sin sistema',
    after: 'Protocolos deportivos listos desde el día 1'
  }, {
    before: 'Horas buscando info en papers sueltos',
    after: 'Todo en 6 tomos de consulta rápida'
  }, {
    before: 'Inseguridad en suplementación y periodización',
    after: 'Criterio clínico y confianza real'
  }, {
    before: 'Cobrás poco sin respaldo profesional',
    after: 'Sistema que justifica honorarios premium'
  }];
  return <section className="py-8 px-3" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <FadeIn className="text-center mb-5" data-id="element-19">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-20">
            Antes vs Después del{' '}
            <span className="text-accent" data-id="element-21">Megapack Nutri Deportiva</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-2 gap-x-3 gap-y-0" data-id="element-22">
          {/* Headers */}
          <div className="text-center mb-2" data-id="element-23">
            <span className="text-sm font-bold text-white/50 uppercase tracking-wider" data-id="element-24">
              ❌ Antes
            </span>
          </div>
          <div className="text-center mb-2" data-id="element-25">
            <span className="text-sm font-bold text-accent uppercase tracking-wider" data-id="element-26">
              ✅ Después
            </span>
          </div>

          {/* Rows */}
          {pairs.map((pair, idx) => <Fragment key={idx} data-id="element-27">
              <FadeIn delay={0.05 * idx} data-id="element-28">
                <div className="bg-white/5 border border-white/10 rounded-lg p-3 mb-2 h-full flex items-start gap-2" data-id="element-29">
                  <XIcon className="text-white/40 shrink-0 mt-0.5" size={14} data-id="element-30" />
                  <span className="text-xs md:text-sm text-white/60" data-id="element-31">
                    {pair.before}
                  </span>
                </div>
              </FadeIn>
              <FadeIn delay={0.05 * idx + 0.05} data-id="element-32">
                <div className="bg-accent/5 border border-accent/25 rounded-lg p-3 mb-2 h-full flex items-start gap-2" data-id="element-33">
                  <CheckIcon className="text-accent shrink-0 mt-0.5" size={14} data-id="element-34" />
                  <span className="text-xs md:text-sm text-white/90 font-medium" data-id="element-35">
                    {pair.after}
                  </span>
                </div>
              </FadeIn>
            </Fragment>)}
        </div>
      </div>
    </section>;
}